export default __webpack_public_path__ + "static/click-collect-5e1f71cd38698790449513cf17860013.png";